module.exports = __webpack_public_path__ + "static/media/contactsImg.85035736.png";